export default "__VITE_PUBLIC_ASSET__5993f815__"